module.exports = __webpack_public_path__ + "static/media/phone_icon.13efef49.svg";